// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1_m4C","title":"Header_title__2xotG","left":"Header_left__3ePhV","clinicName":"Header_clinicName__23Bry"};